/* eslint-disable max-len */
import React from "react";

interface RefreshProps {
  width?: string;
  height?: string;
  color?: string;
  testId?: string;
}

export const Refresh: React.FC<RefreshProps> = ({ width = "21", height = "20", color = "white", testId="refreshIcon" }) => {
  return (
    <svg width={ width } height={ height } viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={ testId }>
      <path d="M15.2085 5.29183C14.0001 4.0835 12.3418 3.3335 10.5001 3.3335C6.8168 3.3335 3.8418 6.31683 3.8418 10.0002C3.8418 13.6835 6.8168 16.6668 10.5001 16.6668C13.6085 16.6668 16.2001 14.5418 16.9418 11.6668H15.2085C14.5251 13.6085 12.6751 15.0002 10.5001 15.0002C7.7418 15.0002 5.50013 12.7585 5.50013 10.0002C5.50013 7.24183 7.7418 5.00016 10.5001 5.00016C11.8835 5.00016 13.1168 5.57516 14.0168 6.4835L11.3335 9.16683H17.1668V3.3335L15.2085 5.29183Z" fill={ color }/>
    </svg>
  );
};
